import { OvenMediaReceiverWebRTCSessionOptions } from '@kalyzee/kast-webrtc-client-module';
import { enumContainsString } from './utils';

export enum StorageCategory {
  TOKEN = 'token',
  MENU = 'menu',
  POPUP = 'popup',
  CONFIG = 'config',
}

export enum TokenType {
  Normal = 'normal',
  Refresh = 'refreshToken',
}

export enum MenuKeys {
  DISPLAY_MODE = 'display_mode',
}

export enum PopupKeys {
  NOT_SHOW_AGAIN = 'not_show_again',
}

const storage = localStorage;

// ---------------- NATIVE ------------------ //

const generateKey = (category : StorageCategory, key : string) => (
  `${category}_${key}`
);

const setItem = (
  category : StorageCategory,
  key: string,
  value: string,
) => storage.setItem(generateKey(category, key), value);

const getItem = (
  category : StorageCategory,
  key: string,
) => storage.getItem(generateKey(category, key));

const removeItem = (
  category : StorageCategory,
  key: string,
) => storage.removeItem(generateKey(category, key));

// ---------------- TOKEN ------------------ //

export const setToken = (
  token: string,
  tokenType: TokenType = TokenType.Normal,
) => setItem(StorageCategory.TOKEN, tokenType, token);

export const getToken = (
  tokenType: TokenType = TokenType.Normal,
) => getItem(StorageCategory.TOKEN, tokenType);

export const removeToken = (
  tokenType: TokenType = TokenType.Normal,
) => removeItem(StorageCategory.TOKEN, tokenType);

// ---------------- CONFIG SELECTOR ------------------ //

export interface SelectedConfig {
  name: string;
  apiUrl: string;
  pullWebMediaUrl?: string;
  pushWebMediaUrl?: string;
  username?: string;
  rtcOptions?: OvenMediaReceiverWebRTCSessionOptions;
  [key: string]: unknown;
}

export enum ConfigKeys {
  SELECTED = 'selected',
}

export const setSelectedConfig = (config: SelectedConfig) =>
  setItem(StorageCategory.CONFIG, ConfigKeys.SELECTED, JSON.stringify(config));

export const getSelectedConfig = (): SelectedConfig | null => {
  const raw = getItem(StorageCategory.CONFIG, ConfigKeys.SELECTED);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const removeSelectedConfig = () =>
  removeItem(StorageCategory.CONFIG, ConfigKeys.SELECTED);

export default {
  // TOKEN
  setToken,
  getToken,
  removeToken,
  // CONFIG
  setSelectedConfig,
  getSelectedConfig,
  removeSelectedConfig,
};
